'use client'

import BannerSlider from "@/components/elements/BannerSlider"

export type AuthBanner = {
  id: string
  url: string
  blurDataURL: string | null
  width: number | null
  height: number | null
}

// The banner column only exists from lg up (see app/(auth)/layout.tsx), so the
// images only load there: phones never download a banner they can't see.
const DESKTOP_QUERY = '(min-width: 1024px)'

export default function AuthBannerSlider({ banners }: { banners: AuthBanner[] }) {
  return (
    <BannerSlider
      intervalMs={4000}
      loadFrom={DESKTOP_QUERY}
      slides={banners.map(b => ({ id: b.id, src: b.url, blurDataURL: b.blurDataURL, width: b.width, height: b.height }))}
    />
  )
}
